import { defineMessages } from 'react-intl';

const messages = defineMessages({
  returnRabbitLogo: {
    description: 'ReturnRabbit Logo',
    defaultMessage: 'ReturnRabbit Logo',
    id: 'iGgCG1',
  },
  returnRabbit: {
    description: 'ReturnRabbit description',
    defaultMessage:
      'Return Rabbit creates a great return experience for both your customers and your team! Currently available as a plug-in for Shopify stores, you can offer a full array of return and exchange options to your Shopify customers, automate return shipping labels, and create a seamless branded return experience.',
    id: 'faqThB',
  },
  generateKey: {
    description: 'ReturnRabbit generate api key',
    defaultMessage: 'Generate API Key',
    id: '2QAeni',
  },
  regenerateKey: {
    description: 'ReturnRabbit regenerate api key',
    defaultMessage: 'Regenerate API Key',
    id: 'Mfy9xI',
  },
  returnRabbitKeyError: {
    description: 'ReturnRabbit generate key error',
    defaultMessage: 'Unable to generate a key. Please contact support.',
    id: 'ms5maq',
  },
  getStarted: {
    description: 'Get started by downloading and installing Return Rabbit on Shopify. ',
    defaultMessage: 'Get started by downloading and installing Return Rabbit on Shopify. ',
    id: 'ODbKtE',
  },
  returnRabbitHeader: {
    description: 'Return Rabbit',
    defaultMessage: 'Return Rabbit',
    id: 'V+v7bb',
  },
  learnMore: {
    description: 'Learn More about Return Rabbit',
    defaultMessage: '<a>Learn More about Return Rabbit</a>',
    id: 'qdiq4N',
  },
  alreadyInstalledOnShopify: {
    description: 'Already installed Return Rabbit on Shopify?',
    defaultMessage: 'Already installed Return Rabbit on Shopify?',
    id: 'c1A0em',
  },
  installOnShopify: {
    description: 'Install on Shopify',
    defaultMessage: 'Install on Shopify',
    id: '6XUXqQ',
  },
  apiKey: {
    description: 'API Key',
    defaultMessage: 'API Key',
    id: 'xLkgWU',
  },
});

export default messages;
